import React from 'react';
import { useDispatch } from 'react-redux';
import {  logoutAdmin } from '../redux/authSlice';
import { useNavigate } from 'react-router-dom';

const Logout = ({ isAdmin }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    if (isAdmin) {
      dispatch(logoutAdmin());
      navigate('/admin/login');
    }
  };

  return <button onClick={handleLogout}>Logout</button>;
};

export default Logout;
